import { useState, Fragment } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import GImage from 'components/common/gImage'
import RichText from 'components/common/richText'
import { Section, ConditionalDiv } from 'components/common/common_styles'
import { SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper'
import { StyledP } from 'components/common/typography'
import { MainContainer, InnerContainer, UpperContainer, TextContainer, ImageContainer, DayNightIconContainer, LodgingButton, Carousel, PaginationContainer } from './homeSiteTypes_styles'

const HomeSiteTypes = () => {
  const { prismicHomePage, allPrismicSiteDetail } = useStaticQuery(query)
  const [isDay, setIsDay] = useState(true)

  return (
    <Section washi>
      <MainContainer padTop={[4, 6]} padBottom={[6, 4]} padLeft={[true, false]} padRight={[true, false]}>
        <InnerContainer>
          <UpperContainer>
            <TextContainer title={prismicHomePage.data.site_type_title}>
              <RichText data={prismicHomePage.data.site_type_copy} />
            </TextContainer>
            <DayNightIconContainer isDay={isDay} setIsDay={setIsDay} />
          </UpperContainer>
          <ConditionalDiv desktopOnly>
            <ImageContainer>
              {allPrismicSiteDetail.edges.map(({ node }) =>
                <Fragment key={node.data.info_title}>
                  <Link to={node.url} aria-label={node.data.info_title}>
                    <GImage data={isDay ? node.data.home_page_day_image : node.data.home_page_night_image} />
                  </Link>
                  <StyledP variant='h5'>{node.data.info_title}</StyledP>
                </Fragment>
              )}
            </ImageContainer>
          </ConditionalDiv>
          <ConditionalDiv mobileOnly>
            <Carousel
              slidesPerView='auto'
              spaceBetween={16}
              centeredSlides={true}
              loop={true}
              pagination={{
                el: '.pagination-container'
              }}
              modules={[Pagination]}
            >
              {allPrismicSiteDetail.edges.map(({ node }) =>
                <SwiperSlide key={node.data.info_title}>
                  <ImageContainer>
                    <Link to={node.url} aria-label={node.data.info_title}>
                      <GImage data={isDay ? node.data.home_page_day_image : node.data.home_page_night_image} />
                    </Link>
                    <StyledP variant='h5'>{node.data.info_title}</StyledP>
                  </ImageContainer>
                </SwiperSlide>
              )}
              <PaginationContainer className='pagination-container' />
            </Carousel>
          </ConditionalDiv>
          <LodgingButton link={prismicHomePage.data.site_type_button_link}>{prismicHomePage.data.site_type_button_title}</LodgingButton>
        </InnerContainer>
      </MainContainer>
    </Section>
  )
}

export default HomeSiteTypes

export const query = graphql`
  query {
    prismicHomePage {
      data {
        site_type_title
        site_type_copy {
          richText
        }
        site_type_button_title
        site_type_button_link
      }
    }
    allPrismicSiteDetail(
      sort: {data: {order: ASC}}
      filter: {data: {active: {eq: true}}}
    ) {
      edges {
        node {
          url
          data {
            home_page_day_image {
              gatsbyImageData
              alt
            }
            home_page_night_image {
              gatsbyImageData
              alt
            }
            info_title
          }
        }
      }
    }
  }
`
